import Vue from 'vue';
import vueRouter from 'vue-router';
import { createSandbox } from 'vue-kindergarten';
import store from '@/store';
import routes from './routes.js';
import RouteGoverness from '@/permissions/routeGoverness.js';
Vue.use(vueRouter);

let router = new vueRouter({
    mode: 'history',
    routes
});

// Use the router before each for simple auth checks for example
router.beforeEach(async (to, from, next) => {

    console.log('beforeRoute',to.meta);
    
    store.state.showMenu = to.meta.menu === undefined ? true : to.meta.menu;
    store.state.showProfile = to.meta.profile === undefined ? true : to.meta.profile;
    // 
    // IF TOKEN IS AVAILABLE & NEEDED
    //
    let authRoutes = ['login', 'register'];
    // CHECK IF AUTHENTICATED
    let authenticate = await store.dispatch('user/authenticate');
    // CHECK IF TO ROUTE NEED AUTH
    if(authRoutes.includes(to.name) && authenticate){
        if(store.getters['user/isApproved'] && to.meta.auth === true){
       
            if(store.getters['user/isFreelancer'] ){
                next({name: 'payment'});
                return;
            }else{
                next({name: 'dashboard'});
            }
        
        }
        // IF ROUTE IS IN AUTHROUTES GO TO DASHBOARD
        next({name: 'dashboard'});
    }
    else if (to.meta.auth === true && !store.getters['user/isAuthenticated']) {
        // IF ROUTE IS IN AUTHROUTES GO TO LOGIN
        next('/user/login');
        return;
    }
    else if (to.meta.paywall === true && store.getters['user/isFreelancer'] && !store.getters['user/hasPayedSubscription']) {
        // IF ROUTE IS AFTER PAYWALL GO TO PAYMENT
        next('/payment');
        return;
    }
    else if(!store.getters['user/isApproved'] && to.meta.auth === true){
        if(to.name === 'user' || to.name ==='useredit' || to.name === 'login'){
            next();
            return false;
        }else{
            if(store.getters['user/isFreelancer'] || store.getters['user/isTemp']){
                next({name: 'introduction'});
            }else{
                next({name: 'user'});
            }
        }
    }
    else{
        
        // 
        // WE HAVE AUTHENTICATED WITH THE API
        // PERMISSIONS CHECK FOR ROUTE BASED ON USER ROLE
        //
        to.matched.some((routeRecord) => {
            const perimeter = routeRecord.meta.perimeter;
            const Governess = routeRecord.meta.governess || RouteGoverness;
            const action = routeRecord.meta.perimeterAction || 'route';
            if (perimeter) {
                const sandbox = createSandbox(store.state.user.data, {
                    governess: new Governess(),
                    perimeters: [
                        perimeter,
                    ],
                });
                return sandbox.guard(action, { to, from, next });
            }
        
            return next();
        });
    }


});
export default router;



// WEBPACK FOOTER //
// ./src/routes/index.js